<script setup lang="ts">
// PROPS
interface Props {
    a11yTitle: string;
    overlay?: boolean;
}

const { a11yTitle, overlay = false } = defineProps<Props>();

// COMPOSABLES
const { isMobileOrTablet } = useResponsive();

// DATA
const isOpen = ref(false);

// METHODS
const open = (): void => {
    isOpen.value = true;
};

const close = (): void => {
    isOpen.value = false;
};
</script>

<template>
    <template v-if="isMobileOrTablet">
        <div class="sticky inset-x-0 bottom-0 overflow-clip rounded-t-lg bg-white">
            <div class="flex flex-col items-center justify-center rounded-t-lg border-t border-b border-neutral-300" @click="open">
                <UIcon name="lucide:chevron-up" class="text-toned h-6 w-6" />
            </div>
            <slot name="compact" :open="open" />
        </div>

        <UDrawer
            v-model:open="isOpen"
            :overlay="overlay"
            :ui="{ container: 'max-h-[90vh] h-max' }"
            :title="a11yTitle"
            v-bind="modalNoDescAriaFixupProps"
        >
            <template #content>
                <div class="flex flex-col items-center justify-center border-b border-neutral-300" @click="close">
                    <UIcon name="lucide:chevron-down" class="text-toned h-6 w-6" />
                </div>
                <div class="overflow-y-auto">
                    <slot name="expanded" />
                </div>
            </template>
        </UDrawer>
    </template>
</template>
